import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { queryManager } from 'ember-apollo-client';
import { dropTask } from 'ember-concurrency';
import { service } from '@ember/service';
import { action } from '@ember/object';

import clientRecurringServiceSubscriptionsQuery from 'my-phorest/gql/queries/client-recurring-service-subscriptions.graphql';

export default class ClientRecurringSubscriptionService extends Service {
  @queryManager apollo;

  @service appointmentSlideOver;
  @service session;

  @tracked selectedBenefitItem = null;

  @action
  onSelectBenefit(benefitItem) {
    this.selectedBenefitItem = benefitItem;
  }

  @dropTask
  *fetchClientRecurringSubscriptionTask(clientId) {
    if (!this.appointmentSlideOver.displayDate) {
      return [];
    }

    const benefitDate = this.appointmentSlideOver.displayDate
      .toISOString()
      .split('T')[0];

    return yield this.apollo.watchQuery(
      {
        query: clientRecurringServiceSubscriptionsQuery,
        variables: {
          clientId,
          benefitDate,
          branchId: this.session.branch.id,
        },
      },
      'clientRecurringServiceSubscriptions'
    );
  }
}
